import React from "react";
import { any } from "prop-types";
import { useKeycloak } from "@react-keycloak/web";
import AcessoNegado from "../../app/components/shared/AcessoNegado";
import defaultConfig from "../libs/default-config";

const authorizedRoles =
  window.env && window.env.KEYCLOAK_AUTHORIZED_ROLES
    ? window.env.KEYCLOAK_AUTHORIZED_ROLES
    : defaultConfig.keycloak.authorizedRoles;

const hasAuthorizedRole = tokenParsed => {
  const roles = tokenParsed?.realm_access?.roles || [];
  return authorizedRoles.some(role => roles.includes(role));
};

const PrivateRoute = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  // Enquanto o keycloak não inicializou, não renderizar AcessoNegado.
  if (!initialized) return <div />;

  const isAuthenticated = keycloak?.authenticated === true;
  const isAuthorized = isAuthenticated && hasAuthorizedRole(keycloak?.tokenParsed);

  return isAuthorized ? children : <AcessoNegado />;
};

PrivateRoute.propTypes = {
  children: any
};

export default PrivateRoute;
